import React from "react";
import { useBrand } from "../lib/brand";

// Aspect ratio of /qortrace-logo.png (1761 × 406 ≈ 4.337:1).
// We size by height so the wordmark drops in cleanly anywhere — `size` is the
// render height in px (display: block keeps it from picking up text leading).
const LOGO_RATIO = 1761 / 406;

export default function Wordmark({ size = 22, color = "#FFFFFF" }) {
  const { logo } = useBrand();
  // PNG carries the real Helvetica Now Display Bold/Light typesetting baked in
  // — SVG references the unloaded font, so cairo/browsers fall back to wrong
  // glyphs. PNG is the source of truth for the wordmark.
  const src = logo || "/qortrace-logo.png";
  // Drive height from `size` for visual parity with the old text wordmark.
  // 1.85× lands the wordmark at the new larger header size the brand asked for
  // (was 1.6 → bumped ~15% per design feedback).
  const renderedHeight = Math.min(size * 1.85, 64);
  return (
    <img
      src={src}
      alt="QorTrace"
      data-testid="qortrace-wordmark"
      style={{
        height: renderedHeight,
        width: renderedHeight * LOGO_RATIO,
        display: "block",
        userSelect: "none",
      }}
      draggable={false}
    />
  );
}
